import { Clock3, MapPin, TriangleAlert } from "lucide-react";

export default function DispatchCard({ item, onOpen, onDragStart }) {
  return (
    <button
      type="button"
      draggable
      onDragStart={(event) => onDragStart(event, item, "dispatch")}
      onClick={() => onOpen(item)}
      className="w-full rounded-2xl border border-slate-200 bg-white p-3 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            {item.werkbonNummer || "Werkbon"}
          </p>
          <p className="truncate text-sm font-semibold text-slate-950">{item.title}</p>
        </div>
        <div className="flex shrink-0 flex-col items-end gap-1">
          <span className={`rounded-full px-2 py-1 text-[11px] font-semibold ${item.priorityTone}`}>
            {item.priorityLabel}
          </span>
          <span className={`rounded-full px-2 py-1 text-[11px] font-semibold ${item.statusBadgeClass}`}>
            {item.statusLabel}
          </span>
        </div>
      </div>

      <div className="mt-3 space-y-1.5 text-xs text-slate-600">
        <InfoLine icon={MapPin} text={item.locationLabel} />
        <InfoLine icon={Clock3} text={`${item.durationLabel} • ${item.workTypeLabel}`} />
        {item.isBlocked ? <InfoLine icon={TriangleAlert} text="Geblokkeerd" tone="text-rose-700" /> : null}
      </div>
    </button>
  );
}

function InfoLine({ icon: Icon, text, tone = "text-slate-600" }) {
  return (
    <div className={`flex items-center gap-2 ${tone}`}>
      <Icon size={13} />
      <span className="truncate">{text}</span>
    </div>
  );
}
